import { NgModule } from "@angular/core";
import { RouteHistoryModule } from "./route-history.module";

@NgModule({
  imports: [
    RouteHistoryModule
  ],
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./src/app/pillar/layout/layout.module.ts